import React from 'react';
import styled from 'styled-components';
import { Plus } from 'lucide-react';
import { useCreateTicketModal } from '../../context/CreateTicketModalContext';

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 38px;
  padding: 0 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--color-btn-primary-text);
  background: var(--color-btn-primary-bg);
  border: 1px solid var(--color-btn-primary-border);
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.1s ease;

  svg {
    display: block;
  }

  &:hover {
    opacity: 0.88;
  }

  &:active {
    transform: scale(0.98);
  }

  @media (prefers-reduced-motion: reduce) {
    &:active {
      transform: none;
    }
  }
`;

const CreateTicketButton = () => {
  const { openCreateTicket } = useCreateTicketModal();

  return (
    <Button type="button" onClick={openCreateTicket} aria-haspopup="dialog">
      <Plus size={16} strokeWidth={2.25} aria-hidden />
      Criar ticket
    </Button>
  );
};

export default CreateTicketButton;
